import { useTranslation } from 'react-i18next'

import { useAccountReadContext } from '@context/AccountContextContext'
import { useModal } from '@context/ModalsContext'
import { useProductReadContext } from '@context/ProductContext'

import { isTargetProductRegistered } from '@utils/AccountAccess/accountProductStatuses'
import { useActionPage } from '@utils/path'

import { isClientOnCoolOff } from '@model/AccountDetailedDto'

import { ProductSwitchModal } from '@shared/components/Navigation/ProductSwitch/modals/ProductSwitch.modal'
import { RegisterProductModal } from '@shared/components/Navigation/ProductSwitch/modals/RegisterProductModal.modal'
import { ActionModal } from '@shared/modals/Action.modal'
import { InformationModal } from '@shared/modals/Information.modal'

export const useProductSwitch = (onClose?: () => void) => {
  const { t } = useTranslation()
  const { account } = useAccountReadContext()
  const isActionPage = useActionPage()
  const { isDefaultCFDProductType } = useProductReadContext()
  const isProductTypeCFD = isDefaultCFDProductType()

  const registerProductModal = useModal(RegisterProductModal)
  const productSwitchModal = useModal(ProductSwitchModal)
  const coolOffModal = useModal(InformationModal, {
    title: t('Restricted Access'),
    description: t(
      'Access is restricted to this area due to you failing your appropriateness test 3 times'
    ),
  })

  const productSwitchClick = () => {
    if (isClientOnCoolOff(account, isProductTypeCFD)) {
      coolOffModal.open()
    } else if (!isTargetProductRegistered(account, isProductTypeCFD)) {
      registerProductModal.open({ onAccept: onClose })
    } else {
      productSwitchModal.open({ onAccept: onClose })
    }
  }

  const cancelModal = useModal(ActionModal, { onConfirm: productSwitchClick })

  return () => {
    isActionPage ? cancelModal.open() : productSwitchClick()
  }
}
